import { Button } from '@chakra-ui/react';
import { PlusIcon } from '../icons';

interface SidebarNewChatButtonProps {
  onClick: () => void;
  label: string;
}

export const SidebarNewChatButton = ({ onClick, label }: SidebarNewChatButtonProps) => {
  return (
    <Button
      onClick={onClick}
      display="flex"
      w="full"
      alignItems="center"
      gap={2}
      borderRadius="md"
      border="2px"
      borderColor="borders.default"
      bg="gradientPrimary"
      px={4}
      py={3}
      fontSize="sm"
      fontWeight="bold"
      color="text.inverse"
      boxShadow="lg"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: 'xl',
      }}
    >
      <PlusIcon width={20} height={20} />
      {label}
    </Button>
  );
};
